// extracted by mini-css-extract-plugin
export default {"companyPage":"style_companyPage__thmfq"};